<template>
  <v-container
      class="appearance-proof-dummy pa-0"
      fluid
      align-center
      justify-center
      fill-height
    >
    <v-container
      class="appearance-proof"
      fluid
      align-center
      justify-center
      
    >
      <page-title title="Proof Appearance"></page-title>
      <Tabs :settings="tabSettings"></Tabs>
      <v-progress-circular indeterminate v-if="loading" ></v-progress-circular>
      <v-layout
        v-if="!loading"
        fluid
        column
        style="max-width: 350px; height: auto; margin: auto;"
      >
        <v-flex class="text-input-container">
          <label> Proof Card Color </label>
          <v-input v-model="settings.primary_color" solo>
            <verte picker="square" model="hex" v-model="settings.primary_color"
              ><v-layout class="color-input-wrapper">
                <v-flex class="color-preview" :style="previewColor"></v-flex>
                <input type="text" v-model="settings.primary_color" /> </v-layout
            ></verte>
          </v-input>
        </v-flex>
        <v-flex class="text-input-container">
          <label> Widget Position </label>
          <v-layout class="widget-positions">
            <v-flex
              class="widget-position"
              :class="{ selected: settings.position === 'BOTTOM_LEFT' }"
              @click="settings.position = 'BOTTOM_LEFT'"
            >
              <div
                class="position bottom-left"
                :style="selectedWidgetPositionStyle('BOTTOM_LEFT')"
              ></div>
              <div class="position-label">
                Bottom Left
              </div>
            </v-flex>
            <v-flex
              class="widget-position"
              :class="{ selected: settings.position === 'BOTTOM_RIGHT' }"
              @click="settings.position = 'BOTTOM_RIGHT'"
            >
              <div
                class="position bottom-right"
                :style="selectedWidgetPositionStyle('BOTTOM_RIGHT')"
              ></div>
              <div class="position-label">
                Bottom Right
              </div>
            </v-flex>
            <v-flex
              class="widget-position"
              :class="{ selected: settings.position === 'TOP_LEFT' }"
              @click="settings.position = 'TOP_LEFT'"
            >
              <div
                class="position top-left"
                :style="selectedWidgetPositionStyle('TOP_LEFT')"
              ></div>
              <div class="position-label">
                Top Left
              </div>
            </v-flex>
            <v-flex
              class="widget-position"
              :class="{ selected: settings.position === 'TOP_RIGHT' }"
              @click="settings.position = 'TOP_RIGHT'"
            >
              <div
                class="position top-right"
                :style="selectedWidgetPositionStyle('TOP_RIGHT')"
              ></div>
              <div class="position-label">
                Top Right
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex class="text-input-container" style="max-width: 250px;">
          <label>Proof Language </label>
          <v-select
            class="lg-select"
            :items="languages"
            item-text="label"
            item-value="id"
            solo
            v-model="settings.primary_lang"
            @change="$emit('change', formData)"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import formMixins from '@/mixins/forms'
import Tabs from '@/components/Tabs'
import routes from '@/route_names'
import Verte from 'verte'
import 'verte/dist/verte.css'
import proofApi from '@/api/proof'

export default {
  mixins: [formMixins],
  components: { Verte, Tabs },
  name: 'ProofAppearance',
  created() {
    const vm = this
    proofApi
      .getSettings(this.$router.currentRoute.params.campaignId)
      .then(function(res) {
        vm.settings = res.data.results
        vm.loading = false
      })
      .catch(function(res) {
        vm.loading = false
      })
  },
  data: function() {
    return {
      settings: null,
      languages: [{ id: 'en', label: 'English' }],
      loading: true,
      initComplete: false // bad bad bad
    }
  },
  computed: {
    previewColor: function() {
      return { background: this.settings.primary_color }
    },
    tabSettings: function() {
      const tabs = []
      tabs.push({
        id: routes.PROOF_APPEARANCE,
        label: 'Proof Widget'
      })
      return {
        preselected: null,
        tabs: tabs
      }
    }
  },
  watch: {
    settings: {
      handler: function(val) {
        const vm = this
        if (this.settings ) {
          console.log('saving')
          if(vm.initComplete)
            proofApi
              .saveAppearance(
                this.$router.currentRoute.params.campaignId,
                this.settings
              )
              .then(function(res) {})
          else{
            vm.initComplete = true
          }
        }
      },
      deep: true
    }
  },
  methods: {
    selectedWidgetPositionStyle: function(pos) {
      if (pos === this.settings.position) {
        return {
          background: this.settings.primary_color
        }
      }
      return {}
    }
  }
}
</script>

<style lang="stylus">
.appearance-proof-dummy {
  padding-left: 0px
}

.appearance-proof {
    text-align center
    .v-progress-circular {
      margin auto
      }
    .text-input-container {
        margin-bottom 25px
    }

    .color-preview {
        min-width: 40px;
        max-width: 40px;
        height: 40px;
        border-top-left-radius 5px
        border-bottom-left-radius 5px
    }

    .verte {
        max-width 100%
        .verte__guide {
            width auto
            height auto
            max-width 100%
        }
        input {
            min-height 40px
            color: $color-primary;
            border: 1px solid $color-primary-light-8;
            background: $color-primary-light-7;
            border-top-right-radius 5px
            border-bottom-right-radius 5px
            margin-top: 0;
            padding: 6px;
            transition: 500ms;
            margin-bottom 3px
            box-sizing border-box
            font-weight 500
            max-width 161px
            &:focus {
                border: 1px solid $color-primary-light-6;
            }
        }
    }
    .text-input-container {
        input {
            text-align center
        }
    }

    .widget-positions {
        margin-bottom 25px
        .widget-position {
            background: $color-primary-light-7;
            border: 1px solid $color-primary-light-8;
            box-sizing: border-box;
            border-radius: 3px;
            max-width 60px
            min-width 60px
            height 50px
            display flex
            align-items center
            justify-content center
            margin-right 20px
            margin-top 5px
            cursor pointer
            position relative
            transition: all .5s ease;
            &.selected {
                border: 1px solid $color-primary-light-5;
                .position {
                    border: 1px solid $color-primary-light-5;
                }
            }
            .position {
                background: #F1F2F6;
                border: 1px solid #F1F2F6;
                box-sizing: border-box;
                height 8px
                width 25px
                position absolute
                transition: all .5s ease;
                border-radius 0
                &.bottom-left{
                    bottom: 1px
                    left: 1px
                }
                &.bottom-right{
                    bottom: 1px
                    right: 1px
                }
                &.top-left{
                    top: 1px
                    left: 1px
                }
                &.top-right{
                    top: 1px
                    right: 1px
                }
            }
            .position-label {
                font-size: 10px;
                color: $color-primary-light-5;
                bottom: -18px;
                width: 60px;
                position: absolute;
                left: 0;
                text-align center
            }
        }
    }
}
</style>
